import {PdlSectionHeader, PdlHeading, PdlSubheading} from '@pedal/pdl-section-header';
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {FormMessage} from '@/components/containers/my-account/utils/form-message';
import {UserApi} from '@/api/user';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';

const UserAccountBase = {
  components: {PdlFormGroup, PdlSectionHeader, PdlHeading, PdlSubheading},
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  mixins: [FormMessage, TrekValidationMixin],
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  computed: {
    api() {
      return UserApi;
    },
  },
  methods: {
    /**
     * Handle cancel button click.
     */
    cancel() {
      if (this.hasUnsavedChanges) {
        if (window.confirm(this.$t('rcp.challenges.edit.unsaved'))) {
          window.location.href = this.options.cancelUrl;
        }
      } else {
        window.location.href = this.options.cancelUrl;
      }
    },

    /**
     * Handle form submission.
     * @return {Promise<void>}
     */
    submit() {
      this.hideMessage();
      this.v$.$validate().then((isValid) => {
        if (isValid) {
          this.processUpdate();
        }
      });
    },

    /**
     * Process update method (to be implemented in children component).
     * @return {Promise<void>}
     */
    async processUpdate() {
      console.error('processUpdate method not implemented.');
    },
    setHasUnsavedChanges(flag = true) {
      this.hasUnsavedChanges = flag;
    },
  },
  data() {
    return {
      isWorking: false,
      hasUnsavedChanges: false,
    };
  },
};

export {UserAccountBase};
